import { ApiResponse, http } from '@config/api';
import { User } from './usersStore';

export interface CreateUserPayload {
	first_name: string;
	last_name: string;
	country: string;
	phone: string;
}

export interface UpdateUserPayload {
	first_name?: string;
	last_name?: string;
	crops?: string[];
	user_agreed_term_and_condition?: boolean;
	userLanguages?: string[];
	socialLinks?: { [key: string]: string }[];
	is_company?: boolean;
	phone?: string;
	country?: string;
	user_completed_registration?: boolean;
	companies?: {
		company_name: string;
		company_id: string;
	}[];
	profile_image?: string;
	userFiles?: {
		file: string;
	}[];
	about?: string;
	file_section?: string;
	specialties?: string[];
	workingExperiences?: {
		country: string;
		year: string;
	}[];
}

export async function createUser(payload: CreateUserPayload) {
	const response = await http.post<ApiResponse<any>>('users', '', payload);

	return response.data;
}

export async function fetchUsers() {
	const response = await http.get<ApiResponse<User>>('users');

	return response.data.data;
}

export async function getUserById(ids: string[]) {
	const response = await http.get<ApiResponse<User>>(`users`, `request-user/${ids}`);

	return response.data.data;
}

export async function updateUser({
	first_name,
	crops,
	userLanguages,
	socialLinks,
	is_company,
	companies,
	userFiles,
	specialties,
	phone,
	user_agreed_term_and_condition,
	last_name,
	country,
	workingExperiences,
	user_completed_registration,
	about,
	profile_image,
	file_section,
}: UpdateUserPayload) {
	const response = await http.put<ApiResponse<any>>('users', '', {
		first_name,
		country,
		crops,
		userLanguages,
		socialLinks,
		file_section,
		is_company,
		companies,
		userFiles,
		specialties,
		phone,
		user_agreed_term_and_condition,
		last_name,
		workingExperiences,
		user_completed_registration,
		about,
		profile_image,
	});

	return response.data;

	return JSON.parse(
		`{"success":true,"data":{"id":"aaea460b-9ecd-4bcc-b64f-b0ddbd9f4cb1","user_id":"01JJ1NNED80AQ2H6VB87TP564V","first_name":"Lasha","last_name":"ABazashvili","phone":"+995511440450","country":"","is_company":false,"is_active":true,"connection_code":"Q9GK5N","user_agreed_term_and_condition":true,"settings":null,"profile_image":null,"about":null,"user_completed_registration":true,"iban":null,"registration_step":2,"created_at":"2025-01-20T10:56:45.442Z","updated_at":"2025-01-20T10:57:14.278Z","user_crops":[],"user_languages":[],"user_rewies":[],"user_files":[],"company":null,"social_link":{"id":"74f65eec-51e3-4b4c-967c-1170a9f9b3ac","user_id":"01JJ1NNED80AQ2H6VB87TP564V","link":{"linkedin":""},"created_at":"2025-01-20T10:57:14.489Z","updated_at":"2025-01-20T10:57:14.489Z"},"user_specialties":[],"working_experience":[],"role":"SPECIALIST","email":"lasha.abazashvili@gmail.com","unicode":{"alpha_two":"","alpha_three":""}},"error":""}`
	).data;
}

export async function deleteUserFile(fileId: string) {
	const response = await http.delete('users', `delete-user-file/?id=${fileId}`);

	return response.data;
}

export async function deleteUser() {
	const response = await http.delete<ApiResponse<any>>('users', '');

	return response.data;
}

export async function checkUserCompletedRegistration() {
	const response = await http.get<ApiResponse<any>>('users', 'check-registration-step');

	return response.data.data;
}

export async function getUserByConnectionCode(connectionCode: string) {
	const response = await http.get<ApiResponse<any>>('users', `find-by-connection-code`, {
		code: connectionCode,
	});

	return response.data.data;
}

export async function getUserByCropsAndLanguages(
	crop_id: string,
	languages: string[],
	monitoring: boolean = false
) {
	const response = await http.get<ApiResponse<FilterByCropAndLanguagesResponse[]>>(
		'users',
		`filter-by-crop-and-languages`,
		{
			crop_id,
			languages: languages.join(','),
			monitoring: monitoring,
		}
	);

	return response.data;
}

export async function getUserFullDataById(id: string) {
	const response = await http.get<ApiResponse<any>>('users', `get-selected-user/${id}`);

	return (response.data as any).data;
}

export interface FilterByCropAndLanguagesResponse {
	first_name: string;
	last_name: string;
	user_id: string;
}
